import '@arco-design/web-react/dist/css/arco.css';
// ... existing code ...
//index是整个项目的入口
//react 两个必要的核心包
import React from 'react'
import ReactDOM from 'react-dom/client'
//导入项目的根组件
import App from './Pages/App';

// 动态创建全局样式 - 隐藏所有滚动条
const globalStyles = `
  /* 隐藏所有滚动条 */
  * {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  }
  
  *::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  
  body {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  body::-webkit-scrollbar {
    display: none;
  }
  
  /* 确保内容仍然可以滚动，只是隐藏滚动条 */
  html, body {
    overflow: auto;
  }
  
  /* 隐藏所有元素的滚动条 */
  div, section, article, main, aside, nav, header, footer {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  div::-webkit-scrollbar,
  section::-webkit-scrollbar,
  article::-webkit-scrollbar,
  main::-webkit-scrollbar,
  aside::-webkit-scrollbar,
  nav::-webkit-scrollbar,
  header::-webkit-scrollbar,
  footer::-webkit-scrollbar {
    display: none;
  }
`;

// 创建并插入样式标签
const styleElement = document.createElement('style');
styleElement.textContent = globalStyles;
document.head.appendChild(styleElement);

//把APP根组件渲染达到root 为dom的节点上
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />)